import React, { Component } from "react";
import { TextBox, Button } from 'devextreme-react';
import {Validator, RequiredRule, EmailRule} from 'devextreme-react/validator';
import{userServices} from "../../services/user.service";
import notify from 'devextreme/ui/notify';

export class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {email: ""};
    this.valueChanged = this.valueChanged.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  valueChanged(data) {
    this.setState({email: data.value});
  }

  onClick(e){
    this.props.history.push('/');
  }

  onFormSubmit(e) {
    userServices.forgotPassword(this.state.email).then(
      data=> {
        if(data==='Success'){
          notify({position:'top right', message:'A reset password email has been sent to you.',type:'success',maxWidth:200, displayTime:4000});
          this.props.history.push('/');
        }
        else{
          this.setState({email:""});
          notify({position:'top right', message:data,type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
        }
      },
      error=>{
        notify({position:'top right', message:error,type:'error',maxWidth:200, closeOnOutsideClick:false, closeOnClick:true, displayTime:6000});
      }
    );
    e.preventDefault();
  }

  render() {
    return (
      <div className="Login">
        <form onSubmit={this.onFormSubmit}>
          <h3>Forgot password</h3>
          <p>Please enter your email address to reset password. </p>
          <TextBox value={this.state.email} valueChangeEvent={'keyup'} onValueChanged={this.valueChanged}>
              <Validator>
                <RequiredRule message={'Email is required'} />
                <EmailRule message={'Email is invalid'} />
              </Validator>
          </TextBox>
          <br/>
          <Button
            key='btnSubmit'
            width={80}
            height={30}
            text='Submit'
            type='default'
            stylingMode='contained'
            useSubmitBehavior={true}
          />
          &nbsp;
          <Button
            key='btnCancel'
            width={80}
            height={30}
            text='Cancel'
            type='default'
            stylingMode='contained'
            onClick={this.onClick}
          />
        </form>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Pages/ForgotPassword.js